import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from '../Pages/App';
import '../Styles/font/stylesheet.css';
import '../Styles/icomoon/style.css';
import '../Styles/preflight.css';
import '../Styles/style.css';

ReactDOM.render(<App />, document.getElementById('root'));
